
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'
import InfoModal from '@/components/InfoModal.vue'
import FlopModal from '@/components/FlopModal.vue'
import RandomModal from '@/components/RandomModal.vue'
import Moment from 'moment'

@Options({
    components: {
        InfoModal,
        FlopModal,
        RandomModal
    },
    computed: {
        ...mapState(['userInfo', 'aid'])
    },
    data() {
        return {
            isApp: false,
            list: [],
            isLongScreen: false,
            showInfoModal: false,
            textCount: {
                total: 0, 
                surplus: 0,
            },
            modalData: {},
            showRandomModal: false,
            showFlopModal: false,
            loaded: false,
        }
    },
    mounted() {
        this.getCount()
        this.getList() 

        this.isApp = COVERAPP.Attribute.isApp()

        this.$common.pageLoaded()
        this.$common.track('load', '进入记录页')

        const { availWidth, availHeight } = window.screen
        if (availHeight / availWidth > 2) {
            this.isLongScreen = true
        }
    },
    methods: {
        ...mapMutations(["SET_DIALOGDATA"]),
        goWrite() {
            this.$router.push('/select1')
        },
        closeModal() {
            this.showFlopModal = false
            this.showRandomModal = false
        },
        openClick() {
            this.$request('/lottery/cash', {
                aid: this.aid,
                pid: this.modalData.pid
            }, 'put', this.closeModal).then((data: any) => {
                this.modalData.state = 2;
                this.$toast(`${this.modalData.amount}元提现成功`)
                this.closeModal()
                this.getList() 
            }).catch((res: any) => {
                if (res && res.errno == 1001 && res.errmsg == 'V2_ACCOUNT_SIMPLE_BAN') {
                    this.SET_DIALOGDATA({
                        text: '您的微信未实名认证，不能领取红包，请实名认证后领取',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                    this.showModal = false
                } else if (!res || !res.errno || (res.errno && res.errno != 1250 && res.errno != 1010)) {
                    this.$toast('加载失败，请重试！')
                }
            })
        },
        closeInfo() {
            this.showInfoModal = false
        },
        submitInfo(info: any) {
            this.$request('/temporary/2023redpack/address', {
                pid: this.modalData.pid,
                info: info,
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                this.showInfoModal = false
                this.$toast('您的兑奖联系方式已提交成功。')
                this.getList() 
            }).catch((err: any) => {
                this.$toast(err.errmsg || '出错了')
            })
        },
        showInfoClick(item: any) {
            this.showInfoModal = true
            this.modalData = {
                ...item,
                pid: item._id,
            }
        },
        goOpenClick(item: any) {
            this.modalData = {
                ...item,
                pid: item._id,
            }
            if(item.type === 'random') {
                this.showRandomModal = true
            }
            if(item.type === 'flop'){
                this.showFlopModal = true
            }
        },
        getList() {
            this.$toast.loading('加载中')
            this.loaded = false
            this.$request('/temporary/2023redpack/record', {
                aid: this.aid,
                userinfo: this.userInfo,
            }, 'post').then((data: any) => {
                this.$toast.clear()
                this.list = data.list.map((v: any) => {
                    return {
                        ...v,
                        time: Moment(v.luckTime).format('YYYY.MM.DD'),
                        amount: v.amount ? (v.amount / 100).toFixed(2) : 0
                    }
                });
                this.loaded = true
            }).catch((err: any) => {
                this.loaded = true
                this.$toast(err.errmsg || '出错了')
            })
        },
        getCount() {
            this.$request('/temporary/2023redpack/count', {
                aid: this.aid,
                userinfo: this.userInfo,
            }, 'post').then((data: any) => {
                this.textCount = {
                    total: data.total,
                    surplus: data.surplus,
                }
            }).catch((err: any) => {
                this.$toast(err.errmsg || '出错了')
            })
        },
    }
})
export default class Record extends Vue { }
